module.exports = __webpack_public_path__ + "static/iconlabel-sentence-dont-4270462d26caa2a4a287c8dc065e14d8.png";